import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var DEFAULT_AUTO_CLOSE = 3000;
export var notificationReducer = function notificationReducer(state, action) {
  switch (action.type) {
    case 'add':
      {
        var item = state.find(function (el) {
          return el.key === action.item.key;
        });
        if (item) {
          var _item$resetTimer, _item$startTimer;
          (_item$resetTimer = item.resetTimer) === null || _item$resetTimer === void 0 || _item$resetTimer.call(item);
          (_item$startTimer = item.startTimer) === null || _item$startTimer === void 0 || _item$startTimer.call(item);
          return state;
        }
        return [].concat(_toConsumableArray(state), [_objectSpread({
          autoClose: DEFAULT_AUTO_CLOSE
        }, action.item)]);
      }
    case 'remove':
      return state.filter(function (item) {
        return item.key !== action.key;
      });
    case 'update':
      {
        var idx = state.findIndex(function (el) {
          return el.key === action.item.key;
        });
        if (idx >= 0) {
          state[idx] = Object.assign(state[idx], action.item);
        }
        return state;
      }
    case 'clear':
      return [];
    default:
      return state;
  }
};